import { ErmineServerSideRenderingService } from "@amzn/ermine-ssr-sdk";
import {
    DEFAULT_CLIENT_CONFIG,
    getEnvInfo,
    getPortalEndpoint,
} from "../configurations";

let ermineSsrServiceClient: ErmineServerSideRenderingService;

export const getErmineSsrClient = () => {
    if (ermineSsrServiceClient != null) {
        return ermineSsrServiceClient;
    }

    const portalEndpoint =
        process.env.NODE_ENV === "development"
            ? window.location.origin
            : getPortalEndpoint();
    const { region } = getEnvInfo();

    ermineSsrServiceClient = new ErmineServerSideRenderingService({
        ...DEFAULT_CLIENT_CONFIG,
        region: region,
        endpoint: portalEndpoint,
        httpOptions:
            process.env.NODE_ENV === "development"
                ? {
                      xhrWithCredentials: true, // To control cookies and auth headers in browser CORS requests when using a proxy local server.
                  }
                : undefined,
    });

    return ermineSsrServiceClient;
};
